import './collapsible-section.scss'


import {
    faCaretDown,
    faCaretRight
} from '@fortawesome/free-solid-svg-icons';

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const CollapsibleSection = defineComponent({
    // `vue-class-component` used to derive this automatically from the class name; `Vue.extend()`
    // has no such fallback, and `findComponent({ name: ... })` in record-mask-display's test relies
    // on it, so it has to stay explicit post-migration.
    name: 'CollapsibleSection',
    mixins: [reactiveVueMixin],
    props: ['collapseId', 'title', 'visibleAtStart'],
    template: require('./collapsible-section.html'),
    data() {
        return {
            visible: false,

            // Icons
            collapseIcon: faCaretRight,
        }
    },
    mounted() {
        this.subscribeToBus('close_section_topic', () => {
            if (this.visible) {
                this.visible = false;
                this.collapseIcon = faCaretRight;
            }
        })

        this.subscribeToBus('open_section_topic', () => {
            if (!this.visible) {
                this.visible = true;
                this.collapseIcon = faCaretDown;
            }
        })
        this.visible = this.visibleAtStart;
        this.collapseIcon = this.visibleAtStart ? faCaretDown : faCaretRight;
    },
    methods: {
        onTitleClick() {
            this.switchIconDirection();
        },
        switchIconDirection() {
            this.collapseIcon = this.visible ? faCaretRight : faCaretDown;
        },
    },
})
